import { ArrowRight, Building2 } from 'lucide-react';
import { industries, trustedOrganisations } from '../data/site';

type Page = 'home' | 'services' | 'case-studies' | 'industries' | 'about' | 'insights' | 'contact';

export function Industries({ onNavigate }: { onNavigate: (page: Page) => void }) {
  return (
    <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
      <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr]">
        <div>
          <p className="section-eyebrow">Industries</p>
          <h1 className="section-title">Enterprise technology delivery across regulated and high-growth environments.</h1>
          <p className="mt-5 text-lg leading-8 text-slate-600">
            Sector experience matters when platforms need to satisfy governance, security, scalability, and delivery
            pressure at the same time.
          </p>
          <button className="btn-primary mt-8" onClick={() => onNavigate('contact')}>
            Discuss your sector context <ArrowRight size={18} aria-hidden="true" />
          </button>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {industries.map((industry) => (
            <article key={industry} className="rounded border border-slate-200 bg-white p-5 shadow-soft">
              <Building2 className="text-cyan" size={24} aria-hidden="true" />
              <h2 className="mt-4 text-lg font-bold">{industry}</h2>
            </article>
          ))}
        </div>
      </div>

      <div className="mt-14 rounded bg-ink p-8 text-white">
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-cyan">Experience includes</p>
        <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-6">
          {trustedOrganisations.map((name) => (
            <div key={name} className="border border-white/12 bg-white/6 px-4 py-3 text-sm font-bold text-slate-100">
              {name}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
